import React from "react";
import Svg, { Path } from "react-native-svg";

type Props = {
  size?: number;
  color?: string;
};

export default function TikTokSvgIcon({
  size = 18,
  color = "#111827",
}: Props) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M15.2 3.2c.35 2.65 1.9 4.35 4.35 4.55v3.4a7.1 7.1 0 0 1-4.25-1.35v5.95c0 3.05-2.25 5.25-5.35 5.25-2.95 0-5.15-2.05-5.15-4.85 0-3.05 2.45-5.1 5.75-4.85v3.55c-1.35-.2-2.35.42-2.35 1.42 0 .85.68 1.45 1.62 1.45 1.12 0 1.85-.72 1.85-2.02V3.2h3.53Z"
        fill={color}
      />
    </Svg>
  );
}
